import React, { Component } from "react";
import FormInputs from "../../components/UI/FormInputs";
import TableGrid from "../../components/UI/TableGrid";
import {
  stripHtmlTags,
  toQueryString,
  USDateTimeString,
} from "../../utils/commonUtils";
import WithRoutify from "../../hoc/WithRoutify";
import withReduxState from "../../hoc/wReduxState";
import WithRouter from "../../hoc/WithRouter";
import CptService from "../../services/CptService";
import AuditLogService from "../../services/AuditLogService";
import JsonViewModal from "../../components/Modal/JsonViewModal";
import Icons from "../../components/UI/Icons";
import GlobalSearch from "../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch";

class AuditLogList extends Component {
  constructor(props) {
    super(props);
    // Initialize state or bind methods if needed
    const tableHeaders = [
      {
        label: "",
        key: "isActive",
        type: "checkBox",
        changeHandler: this.checkBoxChangeHandler,
      },
      {
        label: "Action",
        key: "action",
        sortName: "action",
        sortable: true,
      },
      {
        label: "Model Type",  
        key: "modelType", 
      },
      {
        label: "Changed Data",
        key: "changedData",
        type:'Actions'
      },
      {
        label: "Orginal Data",
        key: "originalData",
        type:'Actions'
      },
      {
        label: "Created At",
        key: "createdAt",
        sortable: false,
      },
      {
        label: "Updated At",
        key: "updatedAt",
        sortable: false,
      },
      {
        label: "Updated By",
        key: "updatedBy",
        sortable: false,
      },
      {
        label: "Organization",
        key: "organization",
        sortable: false,
      },
    ];
    this.state = {
      filters: {
        search_query: "",
      },
      tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          status: 1000,
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "created_at",
          sort_order: "desc",
          search: {},
        },
      },
      activeEditId: null,
      isModelOpen:false,
      jsonViewData: null,
      
    };
  }

  componentDidMount() {
    this.fetchLogList();
    // Code to run after the component has mounted
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.globalFilter?.AuditLogs !== this.props?.globalFilter?.AuditLogs) {
      this.fetchLogList({
        ...this.state.tableRecords.pagination,
        page: 1,
      });
    }
  };

  componentWillUnmount() {
    // Code to run before the component is unmounted
  }

  handleEvent = () => {
    // Handler for events (e.g., button click)
  };
  addFormHandler = () => {
    this.setState({ isModelOpen: !this.state.isModelOpen });
  };

  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [key]: val,
      },
    });
  };
  render() {
    const { tableRecords, filters, isModelOpen, activeEditId,jsonViewData } = this.state;
    const pathname = this.props?.location?.pathname || "/audit-log";
    return (

      <>
        {
          isModelOpen ?
            <JsonViewModal
              data={jsonViewData}
              modelToggleHandler={this.addFormHandler}

            />
            :
            ''
        }
          <div className="sh_cardBox">
            <div className="sh_cardHeader">
              <div className="form-group d-flex mb-0 align-items-center formheader">
                <div style={{ minWidth: 160 }}>
                  <h6 class="text-lg f-500 mb-0">Audit Log List </h6>
                </div>

                <div className="flex-grow-1 d-flex justify-content-center">
                  <GlobalSearch pathname={pathname} profile={this.props?.profile} />
                </div>

                <div className="d-flex" style={{ minWidth: 380, justifyContent: "flex-end" }}>
                  <div className="form-group-fields row mr-2">
                    <div className="col-12 px-1 d-flex">
                      {/* <div className="input-group input-group-joined input-group-solid">
                        <FormInputs
                          placeholder="AUDIT LOG"
                          value={filters["search_query"]}
                          changeHandler={(val) => this.onChangeFiltersHandler("search_query", val)}
                          className="form-control"
                        />
                      </div>
                      <div className="btn-group pl-2">
                        <button className="btn btn-primary" onClick={() => this.submitFiltersHandler()}>
                          Search
                        </button>
                        <button className="btn btn-outline-secondary" onClick={() => this.clearFiltersHandler()}>
                          Clear
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="sh_cardBody p-0">
              <TableGrid
                addFormHandler={() => this.addFormHandler()}
                hasPagination={true}
                fetchTableRecords={(filters) =>
                  this.fetchLogList(filters)
                }
                {...tableRecords}
              />
            </div>
          </div>
      </>
    );
  }
  submitFiltersHandler = async () => {
    const { filters, tableRecords } = this.state;
    const queryfilters = {
      ...tableRecords.pagination,
      page:1,
      search: filters,
    };
    this.fetchLogList(queryfilters);
  };
  clearFiltersHandler = async () => {
    await this.setState({
      filters: {},
    });
    this.submitFiltersHandler();
  };
  fetchLogList = async (query = {}) => {
    const { tableRecords } = this.state;
    try {
      const globalAuditFilters = this.props?.globalFilter?.AuditLogs || {};
      const urlParams = new URLSearchParams(this.props?.location?.search || "");
      const urlUserId = urlParams.get("user_id");
      const defaultAuditDateRange = this.getDefaultAuditDateRange();

      // `toQueryString` only flattens values under `search`, so merge global filters into `search`
      const mergedSearch = {
        ...defaultAuditDateRange,
        ...(query.search || {}),
        ...globalAuditFilters,
        ...(urlUserId ? { user_id: urlUserId } : {}),
      };

      const queryObj = toQueryString(tableRecords.pagination, {
        ...query,
        search: mergedSearch,
      });
      this.props.Loader(true);
      const response = await AuditLogService.getAuditLogList(queryObj);
      const tableData = response.data.data.map((auditLog, companyIndex) => {
        const createdAt = USDateTimeString(auditLog.created_at);
        const updatedAt = USDateTimeString(auditLog.updated_at);
        let actClr='blue';
        const action=auditLog.action.toUpperCase();
        if (action=='CREATE') {
          actClr='green';
        }
        if (action=='DELETE') {
          actClr='red';
        }        
        return {
          companyIndex: companyIndex,
          isHeading: false,
          rowId: auditLog.id,  
          data: {
            isActive: false, 
            action: auditLog.action.toUpperCase(),  
            modelType:auditLog.model_type_name,
            changedData: [{
              title: 'changedData',
              className:"text-sm",
              label: auditLog.changed_data&&auditLog.changed_data.slice(0, 25) + "....",
              clickHandler: () => this.setState({ isModelOpen: true, jsonViewData: auditLog.changed_data }),
              acl: "any",
            }],
            action: {
              title: action,
              value: <span class={`badge bg-${actClr}-soft text-${actClr}`}>{action}</span>
            },
            organization: auditLog.organization_name || "-",
            originalData: [{
              title: 'originalData',
              className:"text-sm",
              label: auditLog.original_data&&auditLog.original_data.slice(0, 25) + "....",
              clickHandler: () => this.setState({ isModelOpen: true, jsonViewData: auditLog.original_data }),
              acl: "any",
            }],    
            createdAt: createdAt, 
            updatedAt: updatedAt,
            updatedBy:auditLog.updated_by && auditLog.updated_by.first_name + " " +auditLog.updated_by.last_name
          },
        };
      });
      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableHeaders: prevState.tableRecords.tableHeaders,
          tableRows: {
            type: "default",
            status: 200,
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...query,
            totalRecords: response?.data?.total,
          },
        },
      }));
    } catch (err) {
      this.setState({
        tableRecords: {
          ...tableRecords,
          tableRows: {
            ...tableRecords.tableRows,
            status: 200,
          },
        },
      });
      console.log("DataIsse");
      // console.error("Error fetching companies:", err);
    } finally {
      this.props.Loader(false);
    }
  };

  getDefaultAuditDateRange = () => {
    const formatMDY = (dateObj) => {
      const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
      const dd = String(dateObj.getDate()).padStart(2, "0");
      const yyyy = dateObj.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    };

    const now = new Date();
    const oneYearAgo = new Date(now);
    oneYearAgo.setFullYear(now.getFullYear() - 1);

    return {
      date_from: formatMDY(oneYearAgo),
      date_to: formatMDY(now),
    };
  };

  deleteHandler = async (id) => {
    CptService.deleteCpt(id)
      .then((res) => {
        this.fetchLogList();
        this.props.Toast.success("CPT Deleted Succesfully");
      })
      .catch((err) => {
        //
      })
      .finally(() => {
        //
      });
  };
  editHandler = (rowId, data,) => {
    this.setState({
      activeEditId: rowId,
    }, this.addFormHandler())
  };
  checkBoxchangeHandler = (value, e) => {
    const rowId = e.target.id;
    const { tableRows } = this.state.tableRecords;
    //update data based on check box click
    const updatedData = tableRows.data.map((item) => {
      if (item.rowId === rowId) {
        item.data.isActive = value;
      }
      return item;
    });

    this.setState((prevState) => ({
      tableRecords: {
        ...prevState.tableRecords,
        tableRows: {
          data: updatedData,
        },
      },
    }));
  };
}
export default WithRouter(withReduxState(WithRoutify(AuditLogList)));
